import { mergeQueryKeys } from "@lukemorales/query-key-factory"

import { AuthQueryKey } from "./resources/auth"
import { ContentQueryKey } from "./resources/content"
import { DashboardQueryKey } from "./resources/dashboard"
import { GlobalQueryKey } from "./resources/global"
import { NotificationQueryKey } from "./resources/notifications"
import { OrganizationQueryKey } from "./resources/organization"
import { ProfileQueryKey } from "./resources/profile"
import { SchoolQueryKey } from "./resources/school"
import { TeachersQueryKey } from "./resources/teachers"

export const APIQueries = mergeQueryKeys(
  GlobalQueryKey,
  ProfileQueryKey,
  AuthQueryKey,
  SchoolQueryKey,
  NotificationQueryKey,
  ContentQueryKey,
  TeachersQueryKey,
  DashboardQueryKey,
  OrganizationQueryKey,
)
